import { SET_REDIRECT_LOADING } from '../actions';
import { loading } from '../initState';

export default (state = loading, action) => {
    switch (action.type) {
        case SET_REDIRECT_LOADING:
            return { ...state, is_redirect_loading: action.payload };
        default: 
            return state;
    }
}